import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamineeService } from 'src/app/services/examinee.service';
import { Examinee } from 'src/app/shared/models/examinee.model';
import { Project } from 'src/app/shared/models/project.model';
import { Questionnaire } from 'src/app/shared/models/questionnaire.model';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-view-examinee-report',
    templateUrl: './view-examinee-report.component.html',
    styleUrl: './view-examinee-report.component.scss',
    standalone: false
})
export class ViewExamineeReportComponent implements OnInit {

	examinee_id!: number;
	project_id!: number;
	
	examinee!: Examinee;
	questionnaire!: Questionnaire;
	project!: Project;
	final_score!: number;
	final_score_color!: string;

	stress_chart_data: any;
	thresh_chart_data: any;

	loading = true;
	currenttab = 1;

	languages = [
		{ name: 'en', value: 'english'},
		{ name: 'he', value: 'hebrew'}
	]

	colorSchemeLine: string | Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#45cb85', '#4b38b3']
  };

	colorSchemeTheme: string | Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#4897F0', '#f06548']
  };

	showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;
  xAxisLabel = 'Questions';
  showYAxisLabel = false;
  yAxisLabel = 'Cognitive / Emotion';
  showGridLines = false;
	autoScale = false;
	legendPosition = LegendPosition.Below;
	theme: string | null = null;

	constructor(private route: ActivatedRoute, private router: Router, private examineeService: ExamineeService, private authService: AuthService) { }

	ngOnInit(): void {
		// document.documentElement.setAttribute('data-bs-theme', "light");
		this.theme = document.documentElement.getAttribute('data-bs-theme');
		this.route.params.subscribe((params: any) => {
			this.examinee_id = params.examineid;
			this.project_id = params.projectid;

			this.examineeService.getExamineeDetails(this.project_id, this.examinee_id).subscribe({
				next: (response) => {
					this.examinee = response.examinee;
					this.questionnaire = response.questionnaire;
					this.project = response.project;
					this.final_score = response.final_score;
					this.stress_chart_data = response.stress_chart_data;
					this.thresh_chart_data = response.thresh_chart_data;


					if (this.final_score < 25) {
						this.final_score_color = '#40bb82';
					} else {
						if (this.final_score < 50) {
							this.final_score_color = '#ffca5b';
						} else {
							if (this.final_score < 85) {
								this.final_score_color = '#f1963b';
							} else {
								this.final_score_color = '#ee6352';
							}
						}
					}
					this.loading = false;
				},
				error: (err) => {
					this.authService.toastErrorMessage('Error!', 'Somthing went wrong getting examinee report');
					this.goBack();
				}
			})
		});
	}

	getLanguage(lang: string) {
		const foundLanguage = this.languages.find(item => item.name === lang);
  	return foundLanguage ? foundLanguage.value : this.languages[0].value;
	}

	getTotalQuestionCount(): number {
    let totalQuestions = 0;
    
    for (const chapter of this.questionnaire.chapters) {
      totalQuestions += chapter.questions.length;
    }

    return totalQuestions;
  }

	changeTab(tabName: string) {
		
	}

	goBack() {
		this.router.navigate(['/projects/' + this.project_id], { queryParams: { 'tab': 'examinees' } });
	}
}
